module.exports = __webpack_public_path__ + "media/promo/velle/images/top_subs-38dd504a15f156d6c67fe3d2f4fb1ebe.png";